import RegisterForm from "../../components/registerForm/RegisterForm";
import { useParams } from "react-router-dom";
const UserRegisterPage = () => {
    const {id} = useParams();
    return <RegisterForm userId={id} />;
};

export default UserRegisterPage;    
